export default "__VITE_ASSET__BCiQGYJP__"